/*
 * Das Bike – Größenrechner
 * ------------------------------------------------------------------
 * Ein Script für beides: das Popup „Finde deine Größe" auf der Produktseite
 * (snippets/custom-size-calculator.liquid) und die eigene Seite mit
 * Kategorie-Auswahl (sections/custom-size-calculator.liquid).
 *
 * Datenbasis (Richtwerte, Stand 16.09.2026):
 *  - Körpergröße → Rahmenhöhe: Tabellen von bergfreunde.eu (MTB, Rennrad, Trekking, City)
 *  - Schrittlänge → Rahmenhöhe: übliche Faktoren (MTB 0,574 · Rennrad 0,665 · Trekking/City 0,66)
 *  - Buchstabengrößen → Körpergröße: veröffentlichte Tabellen von Cube und Trek (überlappend)
 *  - Kinderräder: Laufradgröße → Körpergröße des Kindes laut woom.com
 *
 * Rechenweg: Körpergröße zählt 60 %, Schrittlänge (falls selbst gemessen) 40 %.
 * Die Schrittlänge wird über das typische Verhältnis 0,47 in eine
 * „Vergleichs-Körpergröße" umgerechnet, damit lange oder kurze Beine den
 * Rahmen in die richtige Richtung schieben. Der automatisch vorbelegte
 * Ø-Wert (0,47 × Körpergröße) zählt NICHT als Messung – er ist rechnerisch
 * neutral und nur ein Anker, damit Kunden eher nachmessen.
 *
 * Je Produkt überschreibbar: Metafeld custom.groessentabelle (mehrzeilig),
 * eine Zeile je Größe im Format  "M: 167-179"  (Größe wie in der Variante,
 * dann Körpergrößen-Bereich in cm). Zeilen, die zu keiner Variante passen,
 * werden ignoriert.
 */
(function () {
  'use strict';
  if (window.__dasBikeSizeCalc) { return; }
  window.__dasBikeSizeCalc = true;

  var INSEAM_RATIO  = 0.47; // typische Schrittlänge ÷ Körpergröße
  var WEIGHT_HEIGHT = 0.6;
  var WEIGHT_INSEAM = 0.4;
  var RULER_PX      = 8;    // Pixel je Zentimeter auf dem Maßband

  var GROUPS = {
    mtb: {
      heightToCm: [[152.5,34.5],[157.5,36.5],[162.5,39],[167.5,41.5],[172.5,43.5],[177.5,45.5],[182.5,47.5],[187.5,50.5],[192.5,53.5],[197.5,56]],
      inseamFactor: 0.574,
      showInch: true,
      letters: { XXS:[140,152], XS:[150,162], S:[158,170], M:[167,179], L:[177,189], XL:[186,197], XXL:[195,210] }
    },
    road: {
      heightToCm: [[157.5,48],[162.5,50],[167.5,52],[172.5,54],[177.5,56],[182.5,58.5],[187.5,61],[192.5,63],[197.5,65]],
      inseamFactor: 0.665,
      letters: { XXS:[150,160], XS:[157,166], S:[163,172], M:[170,180], L:[178,188], XL:[186,195], XXL:[193,205] }
    },
    trekking: {
      heightToCm: [[155,44.5],[165,49.5],[172.5,53],[177.5,55],[182.5,57],[187.5,59],[192.5,61.5],[197.5,64]],
      inseamFactor: 0.66,
      letters: { XXS:[142,152], XS:[150,162], S:[158,170], M:[167,179], L:[177,189], XL:[186,198], XXL:[196,210] }
    },
    city: {
      heightToCm: [[155,45],[165,50],[172.5,53.5],[177.5,56.5],[182.5,59.5],[187.5,62],[192.5,64.5],[197.5,67]],
      inseamFactor: 0.66,
      letters: { XXS:[142,152], XS:[150,162], S:[158,170], M:[167,179], L:[177,189], XL:[186,198], XXL:[196,210] }
    },
    kids: {
      // [Körpergröße von, bis, Laufradgröße] – woom.com, 16.09.2026
      wheels: [[82,100,'12 Zoll'],[95,110,'14 Zoll'],[105,120,'16 Zoll'],[115,130,'20 Zoll'],[125,145,'24 Zoll'],[140,165,'26 Zoll']]
    }
  };

  // Schlüssel = Shopify-Produkttyp
  var TYPES = {
    'Mountainbike':   { group:'mtb',      label:'Mountainbikes',   collection:'mountainbikes' },
    'E-Mountainbike': { group:'mtb',      label:'E-Mountainbikes', collection:'e-bike-mtb' },
    'Rennrad':        { group:'road',     label:'Rennräder',       collection:'rennrader' },
    'E-Rennrad':      { group:'road',     label:'E-Rennräder',     collection:'e-bike-rennrader' },
    'Gravel':         { group:'road',     label:'Gravel-Bikes',    collection:'gravel-bikes' },
    'Cross/Fitness':  { group:'trekking', label:'Fitnessbikes',    collection:'crossbikes-fitnessbikes' },
    'Urbanbike':      { group:'city',     label:'Urbanbikes',      collection:'urbanbikes' },
    'Trekking':       { group:'trekking', label:'Trekkingräder',   collection:'urbanbikes' },
    'E-Trekking':     { group:'trekking', label:'E-Trekkingräder', collection:'e-trekking' },
    'E-City':         { group:'city',     label:'E-City-Bikes',    collection:'e-city-urban' },
    'Kids':           { group:'kids',     label:'Kinderräder',     collection:'kinderfahrraeder' },
    'Jugendrad':      { group:'mtb',      label:'Jugendräder',     collection:'jugendraeder' },
    'Citybike':       { group:'city',     label:'Citybikes',       collection:'citybikes' }
  };

  /* ---------- Hilfsfunktionen ---------- */

  function interp(pts, x) {
    if (x <= pts[0][0]) { return pts[0][1]; }
    var last = pts[pts.length - 1];
    if (x >= last[0]) { return last[1]; }
    for (var i = 1; i < pts.length; i++) {
      if (x <= pts[i][0]) {
        var a = pts[i - 1], b = pts[i];
        return a[1] + (b[1] - a[1]) * (x - a[0]) / (b[0] - a[0]);
      }
    }
    return last[1];
  }

  function fmt(n, d) { return n.toFixed(d || 0).replace('.', ','); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); }
  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) ? n : NaN; }
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
  function combine(a, b) { return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]; }

  // "M" → Bereich; "ML", "M/L", "S/M" → Mitte aus beiden; sonst null
  function letterRange(group, raw) {
    var key = String(raw).toUpperCase().replace(/\s+/g, '');
    var L = group.letters;
    if (!L) { return null; }
    if (L[key]) { return L[key].slice(); }
    var parts = key.split('/');
    if (parts.length === 2 && L[parts[0]] && L[parts[1]]) { return combine(L[parts[0]], L[parts[1]]); }
    if (parts.length === 1) {
      for (var i = 1; i < key.length; i++) {
        var a = key.slice(0, i), b = key.slice(i);
        if (L[a] && L[b]) { return combine(L[a], L[b]); }
      }
    }
    return null;
  }

  // "56 cm", "53/S", "M/56" → 56 ; Laufradgrößen ("24 Zoll") und Kleinkram ("12 cm", "R1") → null
  function numericCm(raw) {
    var s = String(raw);
    if (/zoll|″|"|inch/i.test(s)) { return null; }
    var m = s.match(/(\d{2}(?:[.,]\d)?)/);
    if (!m) { return null; }
    var n = parseFloat(m[1].replace(',', '.'));
    if (n < 40 || n > 70) { return null; }
    return n;
  }

  function classify(group, sizes) {
    var letters = [], numeric = [];
    (sizes || []).forEach(function (s) {
      var r = letterRange(group, s.label);
      if (r) { letters.push({ label:s.label, available:s.available, min:r[0], max:r[1] }); return; }
      var cm = numericCm(s.label);
      if (cm !== null) { numeric.push({ label:s.label, available:s.available, cm:cm }); }
    });
    return { letters:letters, numeric:numeric };
  }

  function parseOverride(text, sizes) {
    if (!text) { return null; }
    var out = [];
    String(text).split(/\r?\n/).forEach(function (line) {
      if (/^\s*#/.test(line)) { return; }
      var m = line.match(/^\s*(.+?)\s*[:=]?\s*(\d{2,3})\s*[-–]\s*(\d{2,3})\s*(?:cm)?\s*$/i);
      if (!m) { return; }
      var lbl = m[1].trim().toLowerCase();
      var s = (sizes || []).filter(function (x) { return String(x.label).trim().toLowerCase() === lbl; })[0];
      if (!s) { return; }
      out.push({ label:s.label, available:s.available, min:+m[2], max:+m[3] });
    });
    return out.length ? out : null;
  }

  // Kinderräder ohne Größenoption: erste Zeile "Körpergröße: 105-120" (Label egal, #-Zeilen sind Notizen)
  function parseKidsRange(text) {
    if (!text) { return null; }
    var lines = String(text).split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      if (/^\s*#/.test(lines[i])) { continue; }
      var m = lines[i].match(/^\s*(.+?)\s*[:=]?\s*(\d{2,3})\s*[-–]\s*(\d{2,3})\s*(?:cm)?\s*$/i);
      if (m && +m[2] < +m[3]) { return [+m[2], +m[3]]; }
    }
    return null;
  }
  function shortTitle(t) { return String(t || '').split(' | ')[0]; }
  // Alle Kinderräder aus dem Katalog, die zur Körpergröße passen – lagernd zuerst, dann die kleinere Größe zuerst
  function catalogFits(ctx, h) {
    return (ctx.kidsCatalog || []).map(function (c) {
      var r = parseKidsRange(c.table);
      return r ? { handle:c.handle, title:c.title, url:c.url, image:c.image, price:c.price, available:!!c.available, range:r } : null;
    }).filter(function (c) { return c && h >= c.range[0] && h <= c.range[1]; })
      .sort(function (a, b) { return (b.available - a.available) || (a.range[0] - b.range[0]); });
  }
  function kidsCard(c) {
    return '<a class="size-calc__alt" href="' + esc(c.url) + '">' +
      (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy" width="64" height="48">' : '<span class="size-calc__alt-noimg"></span>') +
      '<span class="size-calc__alt-body"><span class="size-calc__alt-title">' + esc(shortTitle(c.title)) + '</span>' +
      '<span class="size-calc__alt-meta">' + fmt(c.range[0]) + '–' + fmt(c.range[1]) + ' cm · ' + money(c.price / 100) + '</span></span>' +
      '<span class="size-calc__alt-size' + (c.available ? '' : ' is-out') + '">' + (c.available ? 'sofort lieferbar' : 'lieferbar in 1–2 Wochen') + '</span></a>';
  }

  function pickByRange(items, h) {
    var center = function (r) { return (r.min + r.max) / 2; };
    var inside = items.filter(function (r) { return h >= r.min && h <= r.max; });
    if (inside.length >= 2) {
      inside.sort(function (a, b) { return Math.abs(center(a) - h) - Math.abs(center(b) - h); });
      var two = inside.slice(0, 2).sort(function (a, b) { return center(a) - center(b); });
      return { status:'between', items:two };
    }
    if (inside.length === 1) { return { status:'ok', items:inside }; }
    var dist = function (r) { return h < r.min ? r.min - h : h - r.max; };
    var sorted = items.slice().sort(function (a, b) { return dist(a) - dist(b); });
    if (sorted.length && dist(sorted[0]) <= 5) { return { status:'near', items:[sorted[0]] }; }
    var allMin = Math.min.apply(null, items.map(function (r) { return r.min; }));
    return { status:'none', direction: h < allMin ? 'small' : 'large' };
  }

  function pickByCm(items, cm) {
    var s = items.slice().sort(function (a, b) { return Math.abs(a.cm - cm) - Math.abs(b.cm - cm); });
    if (!s.length) { return { status:'none' }; }
    var d1 = Math.abs(s[0].cm - cm);
    if (d1 > 4) { return { status:'none', direction: cm < s[0].cm ? 'small' : 'large' }; }
    if (s[1] && Math.abs(Math.abs(s[1].cm - cm) - d1) <= 1) {
      var two = s.slice(0, 2).sort(function (a, b) { return a.cm - b.cm; });
      return { status:'between', items:two };
    }
    return { status:'ok', items:[s[0]] };
  }

  /* ---------- Berechnung ---------- */

  function isComputable(ctx) {
    if (ctx.kids) { return !!parseKidsRange(ctx.override); }
    var t = TYPES[ctx.type];
    if (!t || t.group === 'kids') { return false; }
    var g = GROUPS[t.group];
    if (parseOverride(ctx.override, ctx.sizes)) { return true; }
    var c = classify(g, ctx.sizes);
    return !!(c.letters.length || c.numeric.length);
  }

  function computeKidsProduct(ctx, h) {
    var range = parseKidsRange(ctx.override);
    if (!range) { return { status:'not-computable' }; }
    var min = range[0], max = range[1], pos = (h - min) / (max - min);
    var res = { status:'result', kind:'kidsProduct', type:'Kids', typeLabel:'Kinderräder', collection:TYPES.Kids.collection, h:h, hEff:h, range:range };
    if (h < min) { res.fit = 'small'; } else if (h > max) { res.fit = 'big'; } else { res.fit = pos > 0.8 ? 'upper' : (pos < 0.2 ? 'lower' : 'mid'); }
    res.fits = catalogFits(ctx, h).filter(function (c) { return c.handle !== ctx.handle; });
    var name = shortTitle(ctx.title);
    res.pick = { status: (res.fit === 'small' || res.fit === 'big') ? 'nofit' : 'ok', items: (res.fit === 'small' || res.fit === 'big') ? [] : [{ label:name }] };
    res.all = [{ label:name, min:min, max:max, available:true }].concat(res.fits.slice(0, 4).map(function (c) { return { label:shortTitle(c.title), min:c.range[0], max:c.range[1], available:c.available }; }));
    return res;
  }

  function compute(ctx, typeKey, h, inseam) {
    if (ctx.mode === 'product' && ctx.kids) { return computeKidsProduct(ctx, h); }
    var t = TYPES[typeKey];
    if (!t) { return { status:'unknown-type' }; }
    var g = GROUPS[t.group];
    var res = { status:'result', type:typeKey, typeLabel:t.label, group:t.group, collection:t.collection, h:h, inseam:inseam, showInch:!!g.showInch };

    if (t.group === 'kids') {
      var wheels = g.wheels.map(function (w) { return { label:w[2], min:w[0], max:w[1], available:true }; });
      res.kind = 'kids'; res.all = wheels; res.hEff = h;
      res.pick = pickByRange(wheels, h);
      return res;
    }

    var hEff = h, inseamUsed = false, inseamWarn = false;
    if (inseam) {
      var ratio = inseam / h;
      if (ratio < 0.40 || ratio > 0.55) { inseamWarn = true; }
      else { hEff = WEIGHT_HEIGHT * h + WEIGHT_INSEAM * (inseam / INSEAM_RATIO); inseamUsed = true; }
    }
    res.hEff = hEff; res.inseamUsed = inseamUsed; res.inseamWarn = inseamWarn;

    var cmH = interp(g.heightToCm, h);
    res.cm = inseamUsed ? WEIGHT_HEIGHT * cmH + WEIGHT_INSEAM * (inseam * g.inseamFactor) : cmH;

    if (ctx.mode === 'product') {
      var ov = parseOverride(ctx.override, ctx.sizes);
      if (ov) { res.kind = 'letters'; res.source = 'hersteller'; res.all = ov; res.pick = pickByRange(ov, hEff); return res; }
      var c = classify(g, ctx.sizes);
      if (c.letters.length) { res.kind = 'letters'; res.all = c.letters; res.pick = pickByRange(c.letters, hEff); return res; }
      if (c.numeric.length) { res.kind = 'numeric'; res.all = c.numeric; res.pick = pickByCm(c.numeric, res.cm); return res; }
      return { status:'not-computable' };
    }

    var std = Object.keys(g.letters).map(function (k) { return { label:k, min:g.letters[k][0], max:g.letters[k][1], available:true }; });
    res.kind = 'page'; res.all = std;
    res.pick = pickByRange(std, hEff);
    return res;
  }

  /* ---------- Lagerstatus ---------- */

  // Lagerstatus einer Größe in der gerade gewählten Kombination (z. B. Farbe):
  // 'ok' = lagernd, 'other' = nur in anderer Ausführung lagernd, 'none' = nirgends lagernd
  function stockFor(ctx, label) {
    var vs = ctx.variants || [];
    if (!vs.length) { return null; }
    var idx = (ctx.optionPosition || 1) - 1;
    var want = String(label).trim().toLowerCase();
    var cur = ctx.currentOptions || null;
    var same = null, any = false;
    vs.forEach(function (v) {
      if (!v.opts || String(v.opts[idx]).trim().toLowerCase() !== want) { return; }
      if (v.available) { any = true; }
      if (cur && v.opts.every(function (o, i) { return i === idx || String(o) === String(cur[i]); })) { same = v; }
    });
    if (same) { return same.available ? 'ok' : (any ? 'other' : 'none'); }
    return any ? 'ok' : 'none';
  }

  function otherOptionWord(ctx) {
    var names = (ctx.options || []).map(function (o) { return (o.name || o).toString().toLowerCase(); });
    var others = names.filter(function (n, i) { return i !== (ctx.optionPosition || 1) - 1; });
    return (others.length === 1 && others[0] === 'farbe') ? 'Farbe' : 'Ausführung';
  }

  /* ---------- Darstellung ---------- */

  function chip(item, ctx) {
    var st = item.stock || (item.available === false ? 'none' : 'ok');
    var cls = 'size-calc__chip' + (st === 'none' ? ' is-unavailable' : '');
    var note = st === 'none' ? '<small>lieferbar in 1–2 Wochen</small>' : (st === 'other' ? '<small>in anderer ' + otherOptionWord(ctx) + ' sofort lieferbar</small>' : '');
    return '<span class="' + cls + '">' + esc(item.label) + note + '</span>';
  }

  function sizeFilterUrl(collection, label) {
    return '/collections/' + collection + '?' + encodeURIComponent('filter.v.option.größe') + '=' + encodeURIComponent(label);
  }

  // „Warum diese Größe?" – alle Größen als Balken auf einer Achse, deine Position als Linie
  function whyHtml(ctx, res) {
    var all = res.all || [];
    if (!all.length) { return ''; }
    var rec = (res.pick.items || []).map(function (i) { return i.label; });
    var rows = '', caption = '', lo, hi;
    var pos = function (v) { return clamp((v - lo) / (hi - lo) * 100, 0, 100).toFixed(1); };

    if (res.kind === 'numeric') {
      var cms = all.map(function (i) { return i.cm; });
      lo = Math.min.apply(null, cms) - 3; hi = Math.max.apply(null, cms) + 3;
      all.slice().sort(function (a, b) { return a.cm - b.cm; }).forEach(function (it) {
        rows += '<div class="size-calc__why-row' + (rec.indexOf(it.label) !== -1 ? ' is-rec' : '') + '">' +
          '<span class="size-calc__why-label">' + esc(it.label) + '</span>' +
          '<span class="size-calc__why-track"><span class="size-calc__why-dot" style="left:' + pos(it.cm) + '%"></span><span class="size-calc__why-me" style="left:' + pos(res.cm) + '%"></span></span></div>';
      });
      caption = 'Deine rechnerische Rahmenhöhe: ca. ' + fmt(res.cm) + ' cm (Linie). Die Punkte sind die Größen dieses Rads.';
    } else {
      var me = res.hEff;
      lo = Math.min.apply(null, all.map(function (i) { return i.min; })) - 4;
      hi = Math.max.apply(null, all.map(function (i) { return i.max; })) + 4;
      all.slice().sort(function (a, b) { return (a.min + a.max) - (b.min + b.max); }).forEach(function (it) {
        var l = pos(it.min), w = (pos(it.max) - pos(it.min)).toFixed(1);
        rows += '<div class="size-calc__why-row' + (rec.indexOf(it.label) !== -1 ? ' is-rec' : '') + '">' +
          '<span class="size-calc__why-label">' + esc(it.label) + '</span>' +
          '<span class="size-calc__why-track"><span class="size-calc__why-bar" style="left:' + l + '%;width:' + w + '%"><i>' + fmt(it.min) + '–' + fmt(it.max) + '</i></span><span class="size-calc__why-me" style="left:' + pos(me) + '%"></span></span></div>';
      });
      caption = (res.kind === 'kids' || res.kind === 'kidsProduct' ? 'Körpergröße deines Kindes: ' : (res.inseamUsed ? 'Deine Körpergröße mit Schrittlänge verrechnet: ' : 'Deine Körpergröße: ')) + fmt(me) + ' cm (Linie). Balken = Körpergrößen-Bereich je Größe' + (res.source === 'hersteller' ? ' laut Hersteller' : '') + '.';
    }
    return '<details class="size-calc__why"><summary>Warum diese Größe?</summary><div class="size-calc__why-body">' + rows + '<p class="size-calc__why-caption">' + caption + '</p></div></details>';
  }

  function renderKidsProduct(ctx, res) {
    var name = shortTitle(ctx.title), min = res.range[0], max = res.range[1], h = res.h, html = '', text = [], actions = [], list = [], title, chip;
    if (res.fit === 'small') {
      title = 'Noch zu groß'; chip = '<span class="size-calc__chip is-unavailable">Noch zu groß</span>';
      text.push(esc(name) + ' ist für ' + fmt(min) + '–' + fmt(max) + ' cm gemacht. Mit ' + fmt(h) + ' cm ist dein Kind noch ' + fmt(min - h) + ' cm zu klein dafür.');
      list = res.fits;
    } else if (res.fit === 'big') {
      title = 'Schon zu klein'; chip = '<span class="size-calc__chip is-unavailable">Schon zu klein</span>';
      text.push(esc(name) + ' ist für ' + fmt(min) + '–' + fmt(max) + ' cm gemacht. Mit ' + fmt(h) + ' cm ist dein Kind dem Rad entwachsen.');
      list = res.fits;
    } else {
      title = 'Passt'; chip = '<span class="size-calc__chip">Passt</span>';
      text.push(esc(name) + ' ist für ' + fmt(min) + '–' + fmt(max) + ' cm gemacht – mit ' + fmt(h) + ' cm ' + (res.fit === 'upper' ? 'ist dein Kind am oberen Ende und wächst bald heraus.' : (res.fit === 'lower' ? 'ist dein Kind am unteren Ende und hat lange etwas davon.' : 'sitzt es mittendrin.')));
      if (res.fit === 'upper') { list = res.fits.filter(function (c) { return c.range[0] > min; }); }
      actions.push('<button type="button" class="size-calc__action" data-size-calc-close>Passt – weiter zum Rad</button>');
    }
    html += '<p class="size-calc__result-title">' + title + '</p><div class="size-calc__chips">' + chip + '</div>';
    if (list.length) {
      html += text.map(function (t) { return '<p class="size-calc__result-text">' + t + '</p>'; }).join('');
      html += '<div class="size-calc__alts"><p class="size-calc__alts-title">' + (res.fit === 'upper' ? 'Die nächste Größe wäre' : 'Diese Räder passen jetzt') + '</p><div class="size-calc__alt-list">' + list.slice(0, 4).map(kidsCard).join('') + '</div></div>';
    } else {
      if (res.fit === 'small' || res.fit === 'big') {
        text.push('Aktuell haben wir kein anderes Kinderrad für ' + fmt(h) + ' cm im Sortiment. Schreib uns – wir helfen weiter.');
        actions.push('<a class="size-calc__action size-calc__action--ghost" href="#chat">Im Chat fragen</a>');
      }
      html += text.map(function (t) { return '<p class="size-calc__result-text">' + t + '</p>'; }).join('');
    }
    if (actions.length) { html += '<div class="size-calc__actions">' + actions.join('') + '</div>'; }
    html += whyHtml(ctx, res);
    return html;
  }

  // Auslöser-Text nach der Berechnung: zeigt das Ergebnis, ein Klick öffnet zum Ändern
  function updateTriggerLabel(root, res) {
    var label = null;
    if (res && res.status === 'result' && res.pick) {
      if (res.kind === 'kidsProduct') { label = res.pick.status === 'ok' ? 'Passt für dein Kind – ändern' : 'Passt nicht – Alternativen'; }
      else if (res.pick.items && res.pick.items.length) { label = 'Deine Größe: ' + res.pick.items.map(function (i) { return i.label; }).join(' oder ') + ' – ändern'; }
    }
    if (!label) { return; }
    document.querySelectorAll('[data-size-calc-open="' + root.id + '"] [data-size-calc-label]').forEach(function (el) { el.textContent = label; });
  }

  function render(ctx, res) {
    if (res.kind === 'kidsProduct') { return renderKidsProduct(ctx, res); }
    var p = res.pick, items = p.items || [], html = '', text = [], actions = [];
    var isProduct = ctx.mode === 'product';
    var where = isProduct ? 'bei diesem Rad' : 'in dieser Kategorie';
    res.wantAlternatives = false;
    if (isProduct) {
      items = items.map(function (it) {
        var copy = { label:it.label, available:it.available, min:it.min, max:it.max, cm:it.cm };
        var st = stockFor(ctx, it.label);
        if (st) { copy.stock = st; }
        return copy;
      });
    }

    html += '<p class="size-calc__result-title">' + (p.status === 'none' ? 'Leider keine Empfehlung' : 'Unsere Empfehlung') + '</p>';

    if (p.status !== 'none') {
      html += '<div class="size-calc__chips">' + items.map(function (it) { return chip(it, ctx); }).join('<span class="size-calc__chips-sep">oder</span>') + '</div>';
    }

    if (res.kind === 'kids') {
      if (p.status === 'ok')      { text.push('Für ' + fmt(res.h) + ' cm Körpergröße passt ein Rad mit ' + esc(items[0].label) + '.'); }
      if (p.status === 'between') { text.push('Dein Kind liegt zwischen ' + esc(items[0].label) + ' und ' + esc(items[1].label) + '. Bei Kinderrädern gilt: lieber die kleinere Größe – ein zu großes Rad nimmt Sicherheit und Fahrspaß.'); }
      if (p.status === 'near')    { text.push('Knapp außerhalb des üblichen Bereichs – am ehesten passt ' + esc(items[0].label) + '. Am besten kurz mit uns abstimmen.'); }
      if (p.status === 'none')    { text.push(p.direction === 'small' ? 'Für ' + fmt(res.h) + ' cm ist es noch etwas früh für ein Kinderrad – ab etwa 82 cm geht es mit dem Laufrad los.' : 'Ab ' + fmt(res.h) + ' cm passt meist schon ein Erwachsenenrad in XS oder XXS.'); }
      if (!isProduct) {
        var fitsPage = catalogFits(ctx, res.h);
        if (fitsPage.length) { res.kidsListHtml = '<div class="size-calc__alts"><p class="size-calc__alts-title">Diese Räder passen</p><div class="size-calc__alt-list">' + fitsPage.slice(0, 6).map(kidsCard).join('') + '</div></div>'; }
        actions.push('<a class="size-calc__action" href="/collections/' + TYPES.Kids.collection + '">Alle Kinderräder ansehen</a>');
      }
    } else {
      if (p.status === 'ok')      { text.push('Passt am ehesten zu ' + fmt(res.h) + ' cm Körpergröße' + (res.inseamUsed ? ' und ' + fmt(res.inseam) + ' cm Schrittlänge' : '') + '.'); }
      if (p.status === 'between') { text.push('Du liegst zwischen ' + esc(items[0].label) + ' und ' + esc(items[1].label) + '. Sportlich und wendig: ' + esc(items[0].label) + '. Entspannt und laufruhig: ' + esc(items[1].label) + '.'); }
      if (p.status === 'near')    { text.push('Knapp außerhalb des üblichen Bereichs – am ehesten passt ' + esc(items[0].label) + '. Am besten kurz mit uns abstimmen.'); }
      if (p.status === 'none')    { text.push('Für ' + fmt(res.h) + ' cm haben wir ' + where + ' keine passende Größe. Schreib uns – wir finden eine Lösung.'); }

      if (res.inseamUsed && p.status !== 'none') {
        var hi = res.inseam / INSEAM_RATIO;
        if (hi > res.h + 4)      { text.push('Deine Beine sind vergleichsweise lang – das zieht die Empfehlung Richtung größerer Rahmen.'); }
        else if (hi < res.h - 4) { text.push('Deine Beine sind vergleichsweise kurz – das zieht die Empfehlung Richtung kleinerer Rahmen.'); }
      }
      if (res.inseamWarn && p.status !== 'none') { text.push('Die Schrittlänge ' + fmt(res.inseam) + ' cm passt nicht zu ' + fmt(res.h) + ' cm Körpergröße – wir haben nur die Körpergröße verwendet.'); }

      if (res.kind === 'page' || res.kind === 'numeric') {
        text.push('Rahmenhöhe: ca. ' + fmt(res.cm) + ' cm' + (res.showInch ? ' (≈ ' + fmt(res.cm / 2.54, 1) + ' Zoll)' : '') + '.');
      }
      if (res.source === 'hersteller') { text.push('Basis: Größentabelle des Herstellers für dieses Rad.'); }

      if (isProduct && p.status !== 'none') {
        var stocks = items.map(function (it) { return it.stock; });
        var noneAll = stocks.length && stocks.every(function (s) { return s === 'none'; });
        if (noneAll) {
          text.push((items.length > 1 ? 'Beide Größen sind' : 'Größe ' + esc(items[0].label) + ' ist') + ' nicht sofort lieferbar – Lieferzeit ca. 1–2 Wochen. Wenn es schneller gehen soll, schau, welche anderen Räder es in deiner Größe gibt.');
        } else if (stocks.indexOf('other') !== -1) {
          text.push('In der gewählten ' + otherOptionWord(ctx) + ' ist ' + esc(items[stocks.indexOf('other')].label) + ' erst in 1–2 Wochen lieferbar, in einer anderen sofort.');
        }
        items.forEach(function (it) {
          actions.push('<button type="button" class="size-calc__action" data-size-calc-select="' + esc(it.label) + '">Größe ' + esc(it.label) + ' auswählen</button>');
        });
        // Alternativen im Sortiment, wenn die empfohlene Größe hier nirgends lagernd ist
        if (noneAll && res.collection) {
          items.forEach(function (it) {
            actions.push('<a class="size-calc__action size-calc__action--ghost" href="' + sizeFilterUrl(res.collection, it.label) + '">Alle ' + esc(res.typeLabel) + ' in ' + esc(it.label) + ' ansehen</a>');
          });
        }
        if (stocks.some(function (s) { return s && s !== 'ok'; })) { res.wantAlternatives = true; }
      }
      if (!isProduct && res.collection) {
        if (p.status !== 'none') {
          items.forEach(function (it) {
            actions.push('<a class="size-calc__action" href="' + sizeFilterUrl(res.collection, it.label) + '">' + esc(res.typeLabel) + ' in ' + esc(it.label) + '</a>');
          });
        } else {
          actions.push('<a class="size-calc__action" href="/collections/' + res.collection + '">Alle ' + esc(res.typeLabel) + ' ansehen</a>');
        }
      }
    }

    if (p.status === 'none' || p.status === 'near') {
      actions.push('<a class="size-calc__action size-calc__action--ghost" href="#chat">Im Chat fragen</a>');
    }

    html += text.map(function (t) { return '<p class="size-calc__result-text">' + t + '</p>'; }).join('');
    if (res.kidsListHtml) { html += res.kidsListHtml; }
    if (actions.length) { html += '<div class="size-calc__actions">' + actions.join('') + '</div>'; }
    if (res.wantAlternatives) { html += '<div class="size-calc__alts" data-size-calc-alts><p class="size-calc__alts-title">Alternativen werden geladen …</p></div>'; }
    if (p.status !== 'none') { html += whyHtml(ctx, res); }
    return html;
  }

  /* ---------- Alternativen: andere Räder derselben Kategorie in der empfohlenen Größe ---------- */

  var collectionCache = {};
  function fetchCollection(handle) {
    if (!collectionCache[handle]) {
      collectionCache[handle] = fetch('/collections/' + handle + '/products.json?limit=250', { credentials:'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d ? (d.products || []) : null; })
        .catch(function () { return null; });
    }
    return collectionCache[handle];
  }
  function money(n) {
    try { return '€' + n.toLocaleString('de-DE', { minimumFractionDigits:2, maximumFractionDigits:2 }); }  // de-DE: Punkt als Tausender wie im Shop (de-AT setzt ein Leerzeichen)
    catch (e) { return '€' + n.toFixed(2).replace('.', ','); }
  }
  function imgUrl(src, w) { return src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; }
  function sizeIndex(product) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var n = String(o.name || o).toLowerCase();
      if (idx === -1 && (n === 'größe' || n === 'grösse' || n === 'size' || n === 'rahmengröße' || n === 'rahmenhöhe')) { idx = i; }
    });
    return idx;
  }

  function loadAlternatives(ctx, res, box) {
    var t = TYPES[res.type];
    if (!t || !box) { return; }
    var wanted = (res.pick.items || []).map(function (i) { return String(i.label).trim().toLowerCase(); });
    var sizeText = (res.pick.items || []).map(function (i) { return esc(i.label); }).join(' / ');
    var myPrice = ctx.price ? ctx.price / 100 : null;
    fetchCollection(t.collection).then(function (products) {
      if (products === null) { if (box.isConnected) { box.remove(); } return; }  // Endpunkt nicht erreichbar: lieber nichts als eine falsche Aussage
      var hits = [];
      products.forEach(function (p) {
        if (!p || p.handle === ctx.handle) { return; }
        var idx = sizeIndex(p);
        if (idx === -1) { return; }
        var v = (p.variants || []).filter(function (x) {
          return x.available && wanted.indexOf(String(x['option' + (idx + 1)] || '').trim().toLowerCase()) !== -1;
        })[0];
        if (!v) { return; }
        hits.push({ p:p, v:v, size:String(v['option' + (idx + 1)]), sameType: p.product_type === ctx.type, price: parseFloat(v.price) });
      });
      var same = hits.filter(function (h) { return h.sameType; });
      var list = same.length >= 2 ? same : hits;
      list.sort(function (a, b) { return myPrice === null ? 0 : Math.abs(a.price - myPrice) - Math.abs(b.price - myPrice); });
      list = list.slice(0, 4);
      if (!box.isConnected) { return; }
      if (!list.length) {
        box.innerHTML = '<p class="size-calc__alts-title">Derzeit kein anderes Rad dieser Kategorie in ' + sizeText + '.</p>';
        return;
      }
      box.innerHTML = '<p class="size-calc__alts-title">Weitere Räder in ' + sizeText + '</p><div class="size-calc__alt-list">' +
        list.map(function (h) {
          var img = h.p.images && h.p.images[0] ? imgUrl(h.p.images[0].src, 240) : '';
          var title = String(h.p.title || '').split(' | ')[0];
          return '<a class="size-calc__alt" href="/products/' + esc(h.p.handle) + '?variant=' + esc(h.v.id) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="48">' : '<span class="size-calc__alt-noimg"></span>') +
            '<span class="size-calc__alt-body"><span class="size-calc__alt-title">' + esc(title) + '</span>' +
            '<span class="size-calc__alt-meta">' + esc(h.p.vendor || '') + (h.p.vendor ? ' · ' : '') + money(h.price) + '</span></span>' +
            '<span class="size-calc__alt-size">' + esc(h.size) + '</span></a>';
        }).join('') + '</div>';
    });
  }

  /* ---------- Variante im Picker anklicken ---------- */

  function selectVariant(ctx, label) {
    var picker = document.querySelector('variant-picker[handle="' + ctx.handle + '"]') || document.querySelector('variant-picker');
    if (!picker) { return false; }
    var want = String(label).trim().toLowerCase();
    var els = picker.querySelectorAll('label, a.popover-listbox__option');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.textContent.trim().toLowerCase() !== want) { continue; }
      if (el.tagName === 'A') { window.location.href = el.getAttribute('href'); return true; }
      var input = el.control || (el.getAttribute('for') ? document.getElementById(el.getAttribute('for')) : null);
      if (input && input.dataset && input.dataset.optionPosition && ctx.optionPosition && String(input.dataset.optionPosition) !== String(ctx.optionPosition)) { continue; }
      el.click();
      try { picker.scrollIntoView({ behavior:'smooth', block:'center' }); } catch (e) {}
      return true;
    }
    return false;
  }

  /* ---------- Merken (nur Komfort, kein Tracking) ---------- */

  function remember(h, i) { try { localStorage.setItem('dasbike_size', JSON.stringify({ h:h, i:i })); } catch (e) {} }
  function recall() { try { return JSON.parse(localStorage.getItem('dasbike_size') || 'null'); } catch (e) { return null; } }

  function track(ctx, res) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'size_calc',
        size_calc_mode: ctx.mode,
        size_calc_type: res.type || null,
        size_calc_height: res.h || null,
        size_calc_inseam: !!res.inseamUsed,
        size_calc_status: res.pick ? res.pick.status : res.status,
        size_calc_result: res.pick && res.pick.items ? res.pick.items.map(function (i) { return i.label; }).join('|') : null
      });
    } catch (e) {}
  }

  /* ---------- Maßband unter dem Eingabefeld ---------- */

  function initRuler(ruler, input) {
    var min = +ruler.getAttribute('data-min'), max = +ruler.getAttribute('data-max');
    var start = +ruler.getAttribute('data-start') || Math.round((min + max) / 2);
    var track = ruler.querySelector('.size-calc__ruler-track');
    if (!track || !(max > min)) { return; }
    var frag = document.createDocumentFragment();
    for (var v = min; v <= max; v++) {
      var t = document.createElement('span');
      t.className = 'size-calc__tick' + (v % 10 === 0 ? ' is-10' : (v % 5 === 0 ? ' is-5' : ''));
      t.style.left = ((v - min) * RULER_PX) + 'px';
      if (v % 10 === 0) { var l = document.createElement('i'); l.textContent = v; t.appendChild(l); }
      frag.appendChild(t);
    }
    track.appendChild(frag);
    track.style.width = ((max - min) * RULER_PX) + 'px';

    function current() { var n = num(input.value); return isFinite(n) ? clamp(n, min, max) : null; }
    function render() {
      var v = current();
      ruler.classList.toggle('is-empty', v === null);
      var x = ruler.clientWidth / 2 - ((v === null ? start : v) - min) * RULER_PX;
      track.style.transform = 'translateX(' + x + 'px)';
    }
    function set(v) {
      v = clamp(Math.round(v), min, max);
      if (String(v) === String(input.value)) { return; }
      input.value = v;
      input.dispatchEvent(new CustomEvent('input', { bubbles:true, detail:'ruler' }));
    }

    var dragging = false, startX = 0, startV = start, moved = false;
    ruler.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false; startX = e.clientX;
      var c = current(); startV = c === null ? start : c;
      try { ruler.setPointerCapture(e.pointerId); } catch (err) {}
      ruler.classList.add('is-dragging');
      e.preventDefault();
    });
    ruler.addEventListener('pointermove', function (e) {
      if (!dragging) { return; }
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 2) { moved = true; }
      set(startV - dx / RULER_PX);
    });
    function end() {
      if (!dragging) { return; }
      dragging = false; ruler.classList.remove('is-dragging');
      if (!moved && current() === null) { set(startV); }  // Tippen auf leeres Band: Startwert übernehmen
      render();
    }
    ruler.addEventListener('pointerup', end);
    ruler.addEventListener('pointercancel', end);
    // Nur horizontales Wischen (Trackpad) bewegt das Band. Vertikales Rad muss
    // die Seite bzw. den Dialog scrollen – sonst verstellt jedes Scrollen über
    // dem Band den Wert (so gefunden: 178 → 170 beim Scrollen zum Knopf).
    ruler.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || !e.deltaX) { return; }
      e.preventDefault();
      var c = current();
      set((c === null ? start : c) + (e.deltaX > 0 ? 1 : -1));
    }, { passive:false });

    input.addEventListener('input', render);
    window.addEventListener('resize', render);
    render();
    ruler.__render = render;
  }

  /* ---------- Initialisierung je Rechner ---------- */

  function initRoot(root) {
    var ctxEl = root.querySelector('[data-size-calc-context]');
    var ctx;
    try { ctx = JSON.parse(ctxEl.textContent); } catch (e) { return; }
    ctx.mode = ctx.mode || 'page';

    var form   = root.querySelector('[data-size-calc-form]');
    var hIn    = root.querySelector('[data-size-calc-height]');
    var iIn    = root.querySelector('[data-size-calc-inseam]');
    var out    = root.querySelector('[data-size-calc-result]');
    var errEl  = root.querySelector('[data-size-calc-error]');
    var hLabel = root.querySelector('[data-size-calc-height-label]');
    var hint   = root.querySelector('[data-size-calc-inseam-hint]');
    if (!form || !hIn || !out) { return; }

    if (ctx.mode === 'product' && !isComputable(ctx)) {
      // Kein sinnvoller Rechenweg (z. B. Laufradgrößen, Kinderräder, Sondergrößen): Auslöser verstecken
      document.querySelectorAll('[data-size-calc-open="' + root.id + '"]').forEach(function (b) { b.hidden = true; });
      return;
    }

    var typeKey = ctx.type || null;
    var lastRes = null;
    function isKids() { return !!ctx.kids || !!(TYPES[typeKey] && TYPES[typeKey].group === 'kids'); }
    if (ctx.mode === 'product' && ctx.kids) {
      root.classList.add('size-calc--kids');
      if (hLabel) { hLabel.textContent = 'Körpergröße deines Kindes'; }
      // Kinderräder ohne Größenoption haben keinen Variant-Picker-Link: Auslöser über dem Kaufknopf einsetzen
      if (!(ctx.sizes && ctx.sizes.length) && !document.querySelector('[data-size-calc-open="' + root.id + '"]')) {
        var bb = document.querySelector('form[action*="/cart/add"] buy-buttons') || document.querySelector('buy-buttons');
        var iconEl = root.querySelector('[data-size-calc-icon]');
        var iconHtml = iconEl ? iconEl.innerHTML : '';
        var kr = parseKidsRange(ctx.override);
        var rangeHtml = kr ? '<div class="h-stack gap-2"><span class="text-subdued">Körpergröße:</span><span>' + fmt(kr[0]) + '–' + fmt(kr[1]) + ' cm</span></div>' : '<span></span>';
        if (bb) { bb.insertAdjacentHTML('beforebegin', '<div class="size-calc__kids-row">' + rangeHtml + '<button type="button" class="size-calc__trigger size-calc__trigger--inline" data-size-calc-open="' + root.id + '">' + iconHtml + '<span data-size-calc-label>Passt es meinem Kind?</span></button></div>'); }
      }
    }
    function paint(res) {
      out.innerHTML = render(ctx, res);
      var altBox = out.querySelector('[data-size-calc-alts]');
      if (altBox) { loadAlternatives(ctx, res, altBox); }
    }

    if (ctx.mode === 'product') {
      // Aktuelle Kombination (z. B. Farbe) und Produktbild mitverfolgen
      var picker = document.querySelector('variant-picker[handle="' + ctx.handle + '"]') || document.querySelector('variant-picker');
      var vScript = picker && picker.querySelector('script[data-variant]');
      if (vScript) { try { ctx.currentOptions = JSON.parse(vScript.textContent).options; } catch (e) {} }
      document.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v) { return; }
        if (v.options) { ctx.currentOptions = v.options; }
        var img = root.querySelector('[data-size-calc-thumb]');
        if (img && v.featured_image && v.featured_image.src) {
          img.src = v.featured_image.src.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_120x.$1$2');
        }
        if (lastRes && !out.hidden) { paint(lastRes); }
      });
    }

    // Maßbänder
    root.querySelectorAll('[data-size-calc-ruler]').forEach(function (ruler) {
      var field = ruler.closest('.size-calc__field');
      var input = field && field.querySelector('input');
      if (input) { initRuler(ruler, input); }
    });

    // Schrittlänge vorbelegen (Ø-Wert) – zählt nicht als Messung, bis der Kunde sie ändert
    function setAuto(on) {
      if (!iIn) { return; }
      if (on) { iIn.setAttribute('data-auto', '1'); } else { iIn.removeAttribute('data-auto'); }
      var wrap = iIn.closest('.size-calc__input-wrap');
      if (wrap) { wrap.classList.toggle('is-auto', on); }
      if (hint) { hint.hidden = !on; }
    }
    function isAuto() { return !!(iIn && iIn.getAttribute('data-auto') === '1'); }
    function prefill() {
      if (!iIn || isKids()) { return; }
      var h = num(hIn.value);
      if (!(h >= 120 && h <= 220)) { return; }
      if (iIn.value === '' || isAuto()) {
        iIn.value = Math.round(h * INSEAM_RATIO);
        setAuto(true);
        iIn.dispatchEvent(new CustomEvent('input', { bubbles:true, detail:'auto' }));
      }
    }
    hIn.addEventListener('input', prefill);
    if (iIn) {
      iIn.addEventListener('input', function (e) {
        if (e.detail === 'auto') { return; }
        setAuto(false);
      });
    }

    function applyType(k) {
      typeKey = k;
      var kids = isKids();
      root.classList.toggle('size-calc--kids', kids);
      if (hLabel) { hLabel.textContent = kids ? 'Körpergröße deines Kindes' : 'Deine Körpergröße'; }
      out.hidden = true;
      if (!kids) { prefill(); }
    }

    if (ctx.mode !== 'product') {
      var typeInputs = root.querySelectorAll('[data-size-calc-type]');
      var wanted = null;
      try { wanted = new URLSearchParams(location.search).get('typ'); } catch (e) {}
      typeInputs.forEach(function (inp) {
        if (wanted && inp.value === wanted) { inp.checked = true; }
        inp.addEventListener('change', function () { if (inp.checked) { applyType(inp.value); } });
        if (inp.checked) { applyType(inp.value); }
      });
    }

    var saved = recall();
    if (saved) {
      var lo0 = isKids() ? 70 : 120, hi0 = isKids() ? 180 : 220;
      if (saved.h && !hIn.value && !(ctx.mode === 'product' && (saved.h < lo0 || saved.h > hi0))) { hIn.value = saved.h; hIn.dispatchEvent(new CustomEvent('input', { bubbles:true, detail:'restore' })); }
      if (saved.i && iIn) { iIn.value = saved.i; setAuto(false); iIn.dispatchEvent(new CustomEvent('input', { bubbles:true, detail:'auto' })); }
    }

    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = !msg; } }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      var kids = isKids();
      var h = num(hIn.value);
      var i = iIn && !kids && !isAuto() ? num(iIn.value) : NaN;
      if (!typeKey) { showError('Bitte wähle zuerst eine Radkategorie.'); return; }
      if (!isFinite(h)) { showError('Bitte gib deine Körpergröße in Zentimetern ein.'); hIn.focus(); return; }
      var lo = kids ? 70 : 120, hi = kids ? 180 : 220;
      if (h < lo || h > hi) { showError('Bitte prüfe die Körpergröße – ' + fmt(h) + ' cm liegt außerhalb von ' + lo + '–' + hi + ' cm.'); hIn.focus(); return; }
      if (isFinite(i) && (i < 30 || i > 120)) { showError('Bitte prüfe die Schrittlänge – ' + fmt(i) + ' cm liegt außerhalb von 30–120 cm.'); iIn.focus(); return; }

      var res = compute(ctx, typeKey, h, isFinite(i) ? i : null);
      if (res.status !== 'result') {
        out.innerHTML = '<p class="size-calc__result-title">Keine Empfehlung möglich</p><p class="size-calc__result-text">Für dieses Rad können wir keine Größe berechnen. Schreib uns – wir helfen persönlich weiter.</p><div class="size-calc__actions"><a class="size-calc__action size-calc__action--ghost" href="#chat">Im Chat fragen</a></div>';
      } else {
        lastRes = res;
        paint(res);
        updateTriggerLabel(root, res);
      }
      out.hidden = false;
      remember(h, isFinite(i) ? i : null);
      track(ctx, res);
      try { out.scrollIntoView({ behavior:'smooth', block:'nearest' }); } catch (e2) {}
    });

    out.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-size-calc-select]');
      if (!btn) { return; }
      var ok = selectVariant(ctx, btn.getAttribute('data-size-calc-select'));
      var dlg = root.closest('dialog') || (root.tagName === 'DIALOG' ? root : null);
      if (ok && dlg && dlg.open) { dlg.close(); }
      if (!ok) { showError('Die Größe konnte nicht automatisch gewählt werden – bitte wähle sie oben bei „Größe" selbst.'); }
    });

    // Maßbänder neu ausrichten, sobald der Dialog sichtbar ist (vorher ist clientWidth 0)
    root.__rerenderRulers = function () {
      root.querySelectorAll('[data-size-calc-ruler]').forEach(function (r) { if (r.__render) { r.__render(); } });
    };
  }

  /* ---------- Öffnen / Schließen ---------- */

  document.addEventListener('click', function (e) {
    // Chat-Link im Popup: erst den Dialog schließen (er liegt in der Top-Layer,
    // darüber kann auch der Chat nicht), dann den Chat direkt öffnen.
    var chatLink = e.target.closest('[data-size-calc] a[href="#chat"]');
    if (chatLink) {
      var dlgChat = chatLink.closest('dialog');
      if (dlgChat && dlgChat.open) { dlgChat.close(); }
      var chat = document.querySelector('shopify-chat');
      if (chat && typeof chat.show === 'function') {
        e.preventDefault();
        try { chat.show(); } catch (err) {}
      }
      return;
    }
    var open = e.target.closest('[data-size-calc-open]');
    if (open) {
      e.preventDefault();
      var d = document.getElementById(open.getAttribute('data-size-calc-open'));
      if (d && typeof d.showModal === 'function') {
        if (!d.open) { d.showModal(); }
        if (d.__rerenderRulers) { d.__rerenderRulers(); }
        var h = d.querySelector('[data-size-calc-height]');
        var fine = false;
        try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e3) {}
        if (h && fine) { try { h.focus({ preventScroll:true }); } catch (e2) {} }
      }
      return;
    }
    var close = e.target.closest('[data-size-calc-close]');
    if (close) {
      var dc = close.closest('dialog');
      if (dc) { dc.close(); }
    }
  });

  function boot() {
    document.querySelectorAll('[data-size-calc]').forEach(function (root) {
      if (root.__sizeCalcInit) { return; }
      root.__sizeCalcInit = true;
      initRoot(root);
      if (root.tagName === 'DIALOG') {
        root.addEventListener('click', function (e) { if (e.target === root) { root.close(); } });
      }
    });
    // Auslöser ohne passendes Popup (z. B. Quick-Buy anderer Produkte) verstecken
    document.querySelectorAll('[data-size-calc-open]').forEach(function (b) {
      if (!document.getElementById(b.getAttribute('data-size-calc-open'))) { b.hidden = true; }
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
